import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { TranslationService } from "./i18n";
// language list
import { locale as enLang } from "./i18n/vocabs/en";
import { locale as thLang } from "./i18n/vocabs/th";
import { ThemeModeService } from "./_metronic/partials/layout/theme-mode-switcher/theme-mode.service";
import { LayoutService } from "./_metronic/layout";
import {
  LayoutType,
  ThemeLayout,
} from "./_metronic/layout/core/configs/config";
import { CommonModule } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { BrandLogoComponent } from "src/shared/brand-logo/brand-logo.component";

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "body[root]",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BrandLogoComponent,CommonModule, RouterOutlet, SharedModule],
})
export class AppComponent implements OnInit {
  ThemeLayout = ThemeLayout;
  baseLayout: LayoutType = "light-header";
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private layoutService: LayoutService,
  ) {
    // register translations
    this.translationService.loadTranslations(enLang, thLang);
  }

  ngOnInit() {
    this.translationService.setLanguage("th");
    this.layoutService.setBaseLayoutType(this.baseLayout);
    this.modeService.init();

    setTimeout(() => {
      const splash = document.getElementById("splash-screen");
      if (splash) {
        splash.classList.add("fade-out");
        setTimeout(() => splash.remove(), 300);
      }
    }, 500);
  }
}
